<template>
<div class="apply-warpper">
  <div class="header">
    <div class="logo flex align-center">
      <img src="../../assets/img/chanxuehezuofuwu.png" alt="">
    </div>
  </div>
  <div class="apply-content margin-tb">
    <router-view/>
  </div>
  <div class="footer">
    <div class="bx-content">
      <div class="detailBox flex align-center justify-between">
        <div class="phoneBox">
          <div class="phone-left">
            <img src="../../assets/img/dianhua.png" alt="">
          </div>
          <div class="phone-right">
            <div class="phone-tit">联系电话</div>
            <div class="phone-tex" style="font-size: 22px">010-50838310</div>
          </div>
        </div>
        <div class="phoneBox">
          <div class="phone-left">
            <img src="../../assets/img/youxiang.png" alt="">
          </div>
          <div class="phone-right">
            <div class="phone-tit">电子邮箱</div>
            <div class="phone-tex" style="font-size: 22px">info@cxhzfw.org.cn</div>
          </div>
        </div>
        <div class="phoneBox">
          <div class="phone-left">
            <img src="../../assets/img/dizhi.png" alt="">
          </div>
          <div class="phone-right">
            <div class="phone-tit">机构地址</div>
            <div class="phone-tex" style="font-size: 22px">北京市朝阳区朝外大街甲6号<br>
              万通中心A座
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      版权所有：北京易魔方科技集团有限公司 <a href="http://www.beian.gov.cn" target="_blank">京ICP备15038897号-3 </a>
    </div>
  </div>
</div>
</template>

<script>
export default {
name: "home"
}
</script>

<style scoped lang="scss">
.apply-warpper{
  .header{
    border-bottom: 2px solid #005eb5;
    .logo{
      height: 110px;
      width: 1200px;
      margin: 0 auto;
    }
  }
  .apply-content{
    width: 1200px;
    margin: 30px auto;
    background: #fff;
    padding: 30px;
  }
  .footer{

    .bx-content{
      width: 1200px;
      margin: 0 auto;
      .detailBox{
        height: 120px;
        .phoneBox {
          height: 63px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .phone-left {
            width: 50px;
            height: 50px;
            margin-right: 15px;
             img {
              width: 50px;
              height: 50px;
            }
          }
          .phone-right {
            padding: 8px 0;
            .phone-tit {
              color: #999999;
              font-size: 16px;
              margin-bottom: 5px;
            }
            .phone-tex {
              color: #333;
              font-size: 18px !important;
              line-height: 22px;
              font-weight: bold;
            }
          }
        }
      }

    }


    background: #fff;
    .foot{
      width: 100%;
      height: 50px;
      background-color: #005eb5;
      line-height: 50px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      a{
        color: #fff;
        margin-left: 50px;
      }
    }
  }
}
</style>
